export const stateAndCounty: any = {
  International: ['N/A'],
  //'Other/Unknown': ['N/A'],
  Alabama: [
    'Autauga County',
    'Baldwin County',
    'Barbour County',
    'Bibb County',
    'Blount County',
    'Bullock County',
    'Butler County',
    'Calhoun County',
    'Chambers County',
    'Cherokee County',
    'Chilton County',
    'Choctaw County',
    'Clarke County',
    'Clay County',
    'Cleburne County',
    'Coffee County',
    'Colbert County',
    'Conecuh County',
    'Coosa County',
    'Covington County',
    'Crenshaw County',
    'Cullman County',
    'Dale County',
    'Dallas County',
    'DeKalb County',
    'Elmore County',
    'Escambia County',
    'Etowah County',
    'Fayette County',
    'Franklin County',
    'Geneva County',
    'Greene County',
    'Hale County',
    'Henry County',
    'Houston County',
    'Jackson County',
    'Jefferson County',
    'Lamar County',
    'Lauderdale County',
    'Lawrence County',
    'Lee County',
    'Limestone County',
    'Lowndes County',
    'Macon County',
    'Madison County',
    'Marengo County',
    'Marion County',
    'Marshall County',
    'Mobile County',
    'Monroe County',
    'Montgomery County',
    'Morgan County',
    'Perry County',
    'Pickens County',
    'Pike County',
    'Randolph County',
    'Russell County',
    'St. Clair County',
    'Shelby County',
    'Sumter County',
    'Talladega County',
    'Tallapoosa County',
    'Tuscaloosa County',
    'Walker County',
    'Washington County',
    'Wilcox County',
    'Winston County',
    'N/A',
  ],
  Alaska: [
    'Aleutians East Borough',
    'Aleutians West Census Area',
    'Anchorage Borough',
    'Bethel Census Area',
    'Bristol Bay Borough',
    'Denali Borough',
    'Dillingham Census Area',
    'Fairbanks North Star Borough',
    'Haines Borough',
    'Juneau City and Borough',
    'Kenai Peninsula Borough',
    'Ketchikan Gateway Borough',
    'Kobuk Census Area',
    'Kodiak Island Borough',
    'Lake and Peninsula Borough',
    'Matanuska-Susitna Borough',
    'Nome Census Area',
    'North Slope Borough',
    'Northwest Arctic Borough',
    'Petersburg Borough',
    'Prince of Wales-Hyder Census Area',
    'Sitka Borough',
    'Skagway-Yakutat-Angoon Municipality',
    'Southeast Fairbanks Census Area',
    'Valdez-Cordova Census Area',
    'Wade Hampton Census Area',
    'Wrangell-Petersburg Census Area',
    'Yukon-Koyukuk Census Area',
    'N/A',
  ],
  'American Samoa': ['N/A'],
  Arizona: [
    'Apache County',
    'Cochise County',
    'Coconino County',
    'Gila County',
    'Graham County',
    'Greenlee County',
    'La Paz County',
    'Maricopa County',
    'Mohave County',
    'Navajo County',
    'Pima County',
    'Pinal County',
    'Santa Cruz County',
    'Yavapai County',
    'Yuma County',
    'N/A',
  ],
  Arkansas: [
    'Arkansas County',
    'Ashley County',
    'Baxter County',
    'Benton County',
    'Boone County',
    'Bradley County',
    'Calhoun County',
    'Carroll County',
    'Chicot County',
    'Clark County',
    'Clay County',
    'Cleburne County',
    'Cleveland County',
    'Columbia County',
    'Conway County',
    'Craighead County',
    'Crawford County',
    'Crittenden County',
    'Cross County',
    'Dallas County',
    'Desha County',
    'Drew County',
    'Faulkner County',
    'Franklin County',
    'Fulton County',
    'Garland County',
    'Grant County',
    'Greene County',
    'Hempstead County',
    'Hot Spring County',
    'Howard County',
    'Independence County',
    'Izard County',
    'Jackson County',
    'Jefferson County',
    'Johnson County',
    'Lafayette County',
    'Lawrence County',
    'Lee County',
    'Lincoln County',
    'Little River County',
    'Logan County',
    'Lonoke County',
    'Madison County',
    'Marion County',
    'Miller County',
    'Mississippi County',
    'Monroe County',
    'Montgomery County',
    'Nevada County',
    'Newton County',
    'Ouachita County',
    'Perry County',
    'Phillips County',
    'Pike County',
    'Poinsett County',
    'Polk County',
    'Pope County',
    'Prairie County',
    'Pulaski County',
    'Randolph County',
    'St. Francis County',
    'Saline County',
    'Scott County',
    'Searcy County',
    'Sebastian County',
    'Sevier County',
    'Sharp County',
    'Stone County',
    'Union County',
    'Van Buren County',
    'Washington County',
    'White County',
    'Woodruff County',
    'Yell County',
    'N/A',
  ],
  'Armed Forces Americas': ['N/A'],
  'Armed Forces Europe, Africa, Canada, Middle East': ['N/A'],
  'Armed Forces Pacific': ['N/A'],
  California: [
    'Alameda County',
    'Alpine County',
    'Amador County',
    'Butte County',
    'Calaveras County',
    'Colusa County',
    'Contra Costa County',
    'Del Norte County',
    'El Dorado County',
    'Fresno County',
    'Glenn County',
    'Humboldt County',
    'Imperial County',
    'Inyo County',
    'Kern County',
    'Kings County',
    'Lake County',
    'Lassen County',
    'Los Angeles County',
    'Madera County',
    'Marin County',
    'Mariposa County',
    'Mendocino County',
    'Merced County',
    'Modoc County',
    'Mono County',
    'Monterey County',
    'Napa County',
    'Nevada County',
    'Orange County',
    'Placer County',
    'Plumas County',
    'Riverside County',
    'Sacramento County',
    'San Benito County',
    'San Bernardino County',
    'San Diego County',
    'San Francisco County',
    'San Joaquin County',
    'San Luis Obispo County',
    'San Mateo County',
    'Santa Barbara County',
    'Santa Clara County',
    'Santa Cruz County',
    'Shasta County',
    'Sierra County',
    'Siskiyou County',
    'Solano County',
    'Sonoma County',
    'Stanislaus County',
    'Sutter County',
    'Tehama County',
    'Trinity County',
    'Tulare County',
    'Tuolumne County',
    'Ventura County',
    'Yolo County',
    'Yuba County',
    'N/A',
  ],
  Colorado: [
    'Adams County',
    'Alamosa County',
    'Arapahoe County',
    'Archuleta County',
    'Baca County',
    'Bent County',
    'Boulder County',
    'Chaffee County',
    'Cheyenne County',
    'Clear Creek County',
    'Conejos County',
    'Costilla County',
    'Crowley County',
    'Custer County',
    'Delta County',
    'Denver County',
    'Dolores County',
    'Douglas County',
    'Eagle County',
    'Elbert County',
    'El Paso County',
    'Fremont County',
    'Garfield County',
    'Gilpin County',
    'Grand County',
    'Gunnison County',
    'Hinsdale County',
    'Huerfano County',
    'Jackson County',
    'Jefferson County',
    'Kiowa County',
    'Kit Carson County',
    'Lake County',
    'La Plata County',
    'Larimer County',
    'Las Animas County',
    'Lincoln County',
    'Logan County',
    'Mesa County',
    'Mineral County',
    'Moffat County',
    'Montezuma County',
    'Montrose County',
    'Morgan County',
    'Otero County',
    'Ouray County',
    'Park County',
    'Phillips County',
    'Pitkin County',
    'Prowers County',
    'Pueblo County',
    'Rio Blanco County',
    'Rio Grande County',
    'Routt County',
    'Saguache County',
    'San Juan County',
    'San Miguel County',
    'Sedgwick County',
    'Summit County',
    'Teller County',
    'Washington County',
    'Weld County',
    'Yuma County',
    'N/A',
  ],
  Connecticut: [
    'Fairfield County',
    'Hartford County',
    'Litchfield County',
    'Middlesex County',
    'New Haven County',
    'New London County',
    'Tolland County',
    'Windham County',
    'N/A',
  ],
  Delaware: ['Kent County', 'New Castle County', 'Sussex County', 'N/A'],
  'District of Columbia': ['District of Columbia', 'N/A'],
  'Federated States of Micronesia': ['N/A'],
  Florida: [
    'Alachua County',
    'Baker County',
    'Bay County',
    'Bradford County',
    'Brevard County',
    'Broward County',
    'Calhoun County',
    'Charlotte County',
    'Citrus County',
    'Clay County',
    'Collier County',
    'Columbia County',
    'DeSoto County',
    'Dixie County',
    'Duval County',
    'Escambia County',
    'Flagler County',
    'Franklin County',
    'Gadsden County',
    'Gilchrist County',
    'Glades County',
    'Gulf County',
    'Hamilton County',
    'Hardee County',
    'Hendry County',
    'Hernando County',
    'Highlands County',
    'Hillsborough County',
    'Holmes County',
    'Indian River County',
    'Jackson County',
    'Jefferson County',
    'Lafayette County',
    'Lake County',
    'Lee County',
    'Leon County',
    'Levy County',
    'Liberty County',
    'Madison County',
    'Manatee County',
    'Marion County',
    'Miami-Dade County',
    'Martin County',
    'Monroe County',
    'Nassau County',
    'Okaloosa County',
    'Okeechobee County',
    'Orange County',
    'Osceola County',
    'Palm Beach County',
    'Pasco County',
    'Pinellas County',
    'Polk County',
    'Putnam County',
    'St. Johns County',
    'St. Lucie County',
    'Santa Rosa County',
    'Sarasota County',
    'Seminole County',
    'Sumter County',
    'Suwannee County',
    'Taylor County',
    'Union County',
    'Volusia County',
    'Wakulla County',
    'Walton County',
    'Washington County',
    'N/A',
  ],
  Georgia: [
    'Appling County',
    'Atkinson County',
    'Bacon County',
    'Baker County',
    'Baldwin County',
    'Banks County',
    'Barrow County',
    'Bartow County',
    'Ben Hill County',
    'Berrien County',
    'Bibb County',
    'Bleckley County',
    'Brantley County',
    'Brooks County',
    'Bryan County',
    'Bulloch County',
    'Burke County',
    'Butts County',
    'Calhoun County',
    'Camden County',
    'Candler County',
    'Carroll County',
    'Catoosa County',
    'Charlton County',
    'Chatham County',
    'Chattahoochee County',
    'Chattooga County',
    'Cherokee County',
    'Clarke County',
    'Clay County',
    'Clayton County',
    'Clinch County',
    'Cobb County',
    'Coffee County',
    'Colquitt County',
    'Columbia County',
    'Cook County',
    'Coweta County',
    'Crawford County',
    'Crisp County',
    'Dade County',
    'Dawson County',
    'Decatur County',
    'DeKalb County',
    'Dodge County',
    'Dooly County',
    'Dougherty County',
    'Douglas County',
    'Early County',
    'Echols County',
    'Effingham County',
    'Elbert County',
    'Emanuel County',
    'Evans County',
    'Fannin County',
    'Fayette County',
    'Floyd County',
    'Forsyth County',
    'Franklin County',
    'Fulton County',
    'Gilmer County',
    'Glascock County',
    'Glynn County',
    'Gordon County',
    'Grady County',
    'Greene County',
    'Gwinnett County',
    'Habersham County',
    'Hall County',
    'Hancock County',
    'Haralson County',
    'Harris County',
    'Hart County',
    'Heard County',
    'Henry County',
    'Houston County',
    'Irwin County',
    'Jackson County',
    'Jasper County',
    'Jeff Davis County',
    'Jefferson County',
    'Jenkins County',
    'Johnson County',
    'Jones County',
    'Lamar County',
    'Lanier County',
    'Laurens County',
    'Lee County',
    'Liberty County',
    'Lincoln County',
    'Long County',
    'Lowndes County',
    'Lumpkin County',
    'McDuffie County',
    'McIntosh County',
    'Macon County',
    'Madison County',
    'Marion County',
    'Meriwether County',
    'Miller County',
    'Mitchell County',
    'Monroe County',
    'Montgomery County',
    'Morgan County',
    'Murray County',
    'Muscogee County',
    'Newton County',
    'Oconee County',
    'Oglethorpe County',
    'Paulding County',
    'Peach County',
    'Pickens County',
    'Pierce County',
    'Pike County',
    'Polk County',
    'Pulaski County',
    'Putnam County',
    'Quitman County',
    'Rabun County',
    'Randolph County',
    'Richmond County',
    'Rockdale County',
    'Schley County',
    'Screven County',
    'Seminole County',
    'Spalding County',
    'Stephens County',
    'Stewart County',
    'Sumter County',
    'Talbot County',
    'Taliaferro County',
    'Tattnall County',
    'Taylor County',
    'Telfair County',
    'Terrell County',
    'Thomas County',
    'Tift County',
    'Toombs County',
    'Towns County',
    'Treutlen County',
    'Troup County',
    'Turner County',
    'Twiggs County',
    'Union County',
    'Upson County',
    'Walker County',
    'Walton County',
    'Ware County',
    'Warren County',
    'Washington County',
    'Wayne County',
    'Webster County',
    'Wheeler County',
    'White County',
    'Whitfield County',
    'Wilcox County',
    'Wilkes County',
    'Wilkinson County',
    'Worth County',
    'N/A',
  ],
  Guam: ['N/A'],
  Hawaii: [
    'Hawaii County',
    'Honolulu County',
    'Kalawao County',
    'Kauai County',
    'Maui County',
    'N/A',
  ],
  Idaho: [
    'Hawaii County',
    'Honolulu County',
    'Kalawao County',
    'Kauai County',
    'Maui County',
    'N/A',
  ],
  Illinois: [
    'Adams County',
    'Alexander County',
    'Bond County',
    'Boone County',
    'Brown County',
    'Bureau County',
    'Calhoun County',
    'Carroll County',
    'Cass County',
    'Champaign County',
    'Christian County',
    'Clark County',
    'Clay County',
    'Clinton County',
    'Coles County',
    'Cook County',
    'Crawford County',
    'Cumberland County',
    'DeKalb County',
    'De Witt County',
    'Douglas County',
    'DuPage County',
    'Edgar County',
    'Edwards County',
    'Effingham County',
    'Fayette County',
    'Ford County',
    'Franklin County',
    'Fulton County',
    'Gallatin County',
    'Greene County',
    'Grundy County',
    'Hamilton County',
    'Hancock County',
    'Hardin County',
    'Henderson County',
    'Henry County',
    'Iroquois County',
    'Jackson County',
    'Jasper County',
    'Jefferson County',
    'Jersey County',
    'Jo Daviess County',
    'Johnson County',
    'Kane County',
    'Kankakee County',
    'Kendall County',
    'Knox County',
    'Lake County',
    'LaSalle County',
    'Lawrence County',
    'Lee County',
    'Livingston County',
    'Logan County',
    'McDonough County',
    'McHenry County',
    'McLean County',
    'Macon County',
    'Macoupin County',
    'Madison County',
    'Marion County',
    'Marshall County',
    'Mason County',
    'Massac County',
    'Menard County',
    'Mercer County',
    'Monroe County',
    'Montgomery County',
    'Morgan County',
    'Moultrie County',
    'Ogle County',
    'Peoria County',
    'Perry County',
    'Piatt County',
    'Pike County',
    'Pope County',
    'Pulaski County',
    'Putnam County',
    'Randolph County',
    'Richland County',
    'Rock Island County',
    'St. Clair County',
    'Saline County',
    'Sangamon County',
    'Schuyler County',
    'Scott County',
    'Shelby County',
    'Stark County',
    'Stephenson County',
    'Tazewell County',
    'Union County',
    'Vermilion County',
    'Wabash County',
    'Warren County',
    'Washington County',
    'Wayne County',
    'White County',
    'Whiteside County',
    'Will County',
    'Williamson County',
    'Winnebago County',
    'Woodford County',
    'N/A',
  ],
  Indiana: [
    'Adams County',
    'Allen County',
    'Bartholomew County',
    'Benton County',
    'Blackford County',
    'Boone County',
    'Brown County',
    'Carroll County',
    'Cass County',
    'Clark County',
    'Clay County',
    'Clinton County',
    'Crawford County',
    'Daviess County',
    'Dearborn County',
    'Decatur County',
    'De Kalb County',
    'Delaware County',
    'Dubois County',
    'Elkhart County',
    'Fayette County',
    'Floyd County',
    'Fountain County',
    'Franklin County',
    'Fulton County',
    'Gibson County',
    'Grant County',
    'Greene County',
    'Hamilton County',
    'Hancock County',
    'Harrison County',
    'Hendricks County',
    'Henry County',
    'Howard County',
    'Huntington County',
    'Jackson County',
    'Jasper County',
    'Jay County',
    'Jefferson County',
    'Jennings County',
    'Johnson County',
    'Knox County',
    'Kosciusko County',
    'LaGrange County',
    'Lake County',
    'LaPorte County',
    'Lawrence County',
    'Madison County',
    'Marion County',
    'Marshall County',
    'Martin County',
    'Miami County',
    'Monroe County',
    'Montgomery County',
    'Morgan County',
    'Newton County',
    'Noble County',
    'Ohio County',
    'Orange County',
    'Owen County',
    'Parke County',
    'Perry County',
    'Pike County',
    'Porter County',
    'Posey County',
    'Pulaski County',
    'Putnam County',
    'Randolph County',
    'Ripley County',
    'Rush County',
    'St. Joseph County',
    'Scott County',
    'Shelby County',
    'Spencer County',
    'Starke County',
    'Steuben County',
    'Sullivan County',
    'Switzerland County',
    'Tippecanoe County',
    'Tipton County',
    'Union County',
    'Vanderburgh County',
    'Vermillion County',
    'Vigo County',
    'Wabash County',
    'Warren County',
    'Warrick County',
    'Washington County',
    'Wayne County',
    'Wells County',
    'White County',
    'Whitley County',
    'N/A',
  ],
  Iowa: [
    'Adair County',
    'Adams County',
    'Allamakee County',
    'Appanoose County',
    'Audubon County',
    'Benton County',
    'Black Hawk County',
    'Boone County',
    'Bremer County',
    'Buchanan County',
    'Buena Vista County',
    'Butler County',
    'Calhoun County',
    'Carroll County',
    'Cass County',
    'Cedar County',
    'Cerro Gordo County',
    'Cherokee County',
    'Chickasaw County',
    'Clarke County',
    'Clay County',
    'Clayton County',
    'Clinton County',
    'Crawford County',
    'Dallas County',
    'Davis County',
    'Decatur County',
    'Delaware County',
    'Des Moines County',
    'Dickinson County',
    'Dubuque County',
    'Emmet County',
    'Fayette County',
    'Floyd County',
    'Franklin County',
    'Fremont County',
    'Greene County',
    'Grundy County',
    'Guthrie County',
    'Hamilton County',
    'Hancock County',
    'Hardin County',
    'Harrison County',
    'Henry County',
    'Howard County',
    'Humboldt County',
    'Ida County',
    'Iowa County',
    'Jackson County',
    'Jasper County',
    'Jefferson County',
    'Johnson County',
    'Jones County',
    'Keokuk County',
    'Kossuth County',
    'Lee County',
    'Linn County',
    'Louisa County',
    'Lucas County',
    'Lyon County',
    'Madison County',
    'Mahaska County',
    'Marion County',
    'Marshall County',
    'Mills County',
    'Mitchell County',
    'Monona County',
    'Monroe County',
    'Montgomery County',
    'Muscatine County',
    `O'Brien County`,
    'Osceola County',
    'Page County',
    'Palo Alto County',
    'Plymouth County',
    'Pocahontas County',
    'Polk County',
    'Pottawattamie County',
    'Poweshiek County',
    'Ringgold County',
    'Sac County',
    'Scott County',
    'Shelby County',
    'Sioux County',
    'Story County',
    'Tama County',
    'Taylor County',
    'Union County',
    'Van Buren County',
    'Wapello County',
    'Warren County',
    'Washington County',
    'Wayne County',
    'Webster County',
    'Winnebago County',
    'Winneshiek County',
    'Woodbury County',
    'Worth County',
    'Wright County',
    'N/A',
  ],
  Kansas: [
    'Allen County',
    'Anderson County',
    'Atchison County',
    'Barber County',
    'Barton County',
    'Bourbon County',
    'Brown County',
    'Butler County',
    'Chase County',
    'Chautauqua County',
    'Cherokee County',
    'Cheyenne County',
    'Clark County',
    'Clay County',
    'Cloud County',
    'Coffey County',
    'Comanche County',
    'Cowley County',
    'Crawford County',
    'Decatur County',
    'Dickinson County',
    'Doniphan County',
    'Douglas County',
    'Edwards County',
    'Elk County',
    'Ellis County',
    'Ellsworth County',
    'Finney County',
    'Ford County',
    'Franklin County',
    'Geary County',
    'Gove County',
    'Graham County',
    'Grant County',
    'Gray County',
    'Greeley County',
    'Greenwood County',
    'Hamilton County',
    'Harper County',
    'Harvey County',
    'Haskell County',
    'Hodgeman County',
    'Jackson County',
    'Jefferson County',
    'Jewell County',
    'Johnson County',
    'Kearny County',
    'Kingman County',
    'Kiowa County',
    'Labette County',
    'Lane County',
    'Leavenworth County',
    'Lincoln County',
    'Linn County',
    'Logan County',
    'Lyon County',
    'McPherson County',
    'Marion County',
    'Marshall County',
    'Meade County',
    'Miami County',
    'Mitchell County',
    'Montgomery County',
    'Morris County',
    'Morton County',
    'Nemaha County',
    'Neosho County',
    'Ness County',
    'Norton County',
    'Osage County',
    'Osborne County',
    'Ottawa County',
    'Pawnee County',
    'Phillips County',
    'Pottawatomie County',
    'Pratt County',
    'Rawlins County',
    'Reno County',
    'Republic County',
    'Rice County',
    'Riley County',
    'Rooks County',
    'Rush County',
    'Russell County',
    'Saline County',
    'Scott County',
    'Sedgwick County',
    'Seward County',
    'Shawnee County',
    'Sheridan County',
    'Sherman County',
    'Smith County',
    'Stafford County',
    'Stanton County',
    'Stevens County',
    'Sumner County',
    'Thomas County',
    'Trego County',
    'Wabaunsee County',
    'Wallace County',
    'Washington County',
    'Wichita County',
    'Wilson County',
    'Woodson County',
    'Wyandotte County',
    'N/A',
  ],
  Kentucky: [
    'Adair County',
    'Allen County',
    'Anderson County',
    'Ballard County',
    'Barren County',
    'Bath County',
    'Bell County',
    'Boone County',
    'Bourbon County',
    'Boyd County',
    'Boyle County',
    'Bracken County',
    'Breathitt County',
    'Breckinridge County',
    'Bullitt County',
    'Butler County',
    'Caldwell County',
    'Calloway County',
    'Campbell County',
    'Carlisle County',
    'Carroll County',
    'Carter County',
    'Casey County',
    'Christian County',
    'Clark County',
    'Clay County',
    'Clinton County',
    'Crittenden County',
    'Cumberland County',
    'Daviess County',
    'Edmonson County',
    'Elliott County',
    'Estill County',
    'Fayette County',
    'Fleming County',
    'Floyd County',
    'Franklin County',
    'Fulton County',
    'Gallatin County',
    'Garrard County',
    'Grant County',
    'Graves County',
    'Grayson County',
    'Green County',
    'Greenup County',
    'Hancock County',
    'Hardin County',
    'Harlan County',
    'Harrison County',
    'Hart County',
    'Henderson County',
    'Henry County',
    'Hickman County',
    'Hopkins County',
    'Jackson County',
    'Jefferson County',
    'Jessamine County',
    'Johnson County',
    'Kenton County',
    'Knott County',
    'Knox County',
    'Larue County',
    'Laurel County',
    'Lawrence County',
    'Lee County',
    'Leslie County',
    'Letcher County',
    'Lewis County',
    'Lincoln County',
    'Livingston County',
    'Logan County',
    'Lyon County',
    'McCracken County',
    'McCreary County',
    'McLean County',
    'Madison County',
    'Magoffin County',
    'Marion County',
    'Marshall County',
    'Martin County',
    'Mason County',
    'Meade County',
    'Menifee County',
    'Mercer County',
    'Metcalfe County',
    'Monroe County',
    'Montgomery County',
    'Morgan County',
    'Muhlenberg County',
    'Nelson County',
    'Nicholas County',
    'Ohio County',
    'Oldham County',
    'Owen County',
    'Owsley County',
    'Pendleton County',
    'Perry County',
    'Pike County',
    'Powell County',
    'Pulaski County',
    'Robertson County',
    'Rockcastle County',
    'Rowan County',
    'Russell County',
    'Scott County',
    'Shelby County',
    'Simpson County',
    'Spencer County',
    'Taylor County',
    'Todd County',
    'Trigg County',
    'Trimble County',
    'Union County',
    'Warren County',
    'Washington County',
    'Wayne County',
    'Webster County',
    'Whitley County',
    'Wolfe County',
    'Woodford County',
    'N/A',
  ],
  Louisiana: [
    'Acadia Parish',
    'Allen Parish',
    'Ascension Parish',
    'Assumption Parish',
    'Avoyelles Parish',
    'Beauregard Parish',
    'Bienville Parish',
    'Bossier Parish',
    'Caddo Parish',
    'Calcasieu Parish',
    'Caldwell Parish',
    'Cameron Parish',
    'Catahoula Parish',
    'Claiborne Parish',
    'Concordia Parish',
    'De Soto Parish',
    'East Baton Rouge Parish',
    'East Carroll Parish',
    'East Feliciana Parish',
    'Evangeline Parish',
    'Franklin Parish',
    'Grant Parish',
    'Iberia Parish',
    'Iberville Parish',
    'Jackson Parish',
    'Jefferson Parish',
    'Jefferson Davis Parish',
    'Lafayette Parish',
    'Lafourche Parish',
    'La Salle Parish',
    'Lincoln Parish',
    'Livingston Parish',
    'Madison Parish',
    'Morehouse Parish',
    'Natchitoches Parish',
    'Orleans Parish',
    'Ouachita Parish',
    'Plaquemines Parish',
    'Pointe Coupee Parish',
    'Rapides Parish',
    'Red River Parish',
    'Richland Parish',
    'Sabine Parish',
    'St. Bernard Parish',
    'St. Charles Parish',
    'St. Helena Parish',
    'St. James Parish',
    'St. John the Baptist Parish',
    'St. Landry Parish',
    'St. Martin Parish',
    'St. Mary Parish',
    'St. Tammany Parish',
    'Tangipahoa Parish',
    'Tensas Parish',
    'Terrebonne Parish',
    'Union Parish',
    'Vermilion Parish',
    'Vernon Parish',
    'Washington Parish',
    'Webster Parish',
    'West Baton Rouge Parish',
    'West Carroll Parish',
    'West Feliciana Parish',
    'Winn Parish',
    'N/A',
  ],
  Maine: [
    'Androscoggin County',
    'Aroostook County',
    'Cumberland County',
    'Franklin County',
    'Hancock County',
    'Kennebec County',
    'Knox County',
    'Lincoln County',
    'Oxford County',
    'Penobscot County',
    'Piscataquis County',
    'Sagadahoc County',
    'Somerset County',
    'Waldo County',
    'Washington County',
    'York County',
    'N/A',
  ],
  'Marshall Islands': ['N/A'],
  Maryland: [
    'Allegany County',
    'Anne Arundel County',
    'Baltimore City',
    'Baltimore County',
    'Calvert County',
    'Caroline County',
    'Carroll County',
    'Cecil County',
    'Charles County',
    'Dorchester County',
    'Frederick County',
    'Garrett County',
    'Harford County',
    'Howard County',
    'Kent County',
    'Montgomery County',
    `Prince George's County`,
    `Queen Anne's County`,
    `St. Mary's County`,
    'Somerset County',
    'Talbot County',
    'Washington County',
    'Wicomico County',
    'Worcester County',
    'N/A',
  ],
  Massachusetts: [
    `Barnstable County`,
    `Berkshire County`,
    `Bristol County`,
    `Dukes County`,
    `Essex County`,
    `Franklin County`,
    `Hampden County`,
    `Hampshire County`,
    `Middlesex County`,
    `Nantucket County`,
    `Norfolk County`,
    `Plymouth County`,
    `Suffolk County`,
    `Worcester County`,
    `N/A`,
  ],
  Michigan: [
    `Middlesex County`,
    `Alcona County`,
    `Alger County`,
    `Allegan County`,
    `Alpena County`,
    `Antrim County`,
    `Arenac County`,
    `Baraga County`,
    `Barry County`,
    `Bay County`,
    `Benzie County`,
    `Berrien County`,
    `Branch County`,
    `Calhoun County`,
    `Cass County`,
    `Charlevoix County`,
    `Cheboygan County`,
    `Chippewa County`,
    `Clare County`,
    `Clinton County`,
    `Crawford County`,
    `Delta County`,
    `Dickinson County`,
    `Eaton County`,
    `Emmet County`,
    `Genesee County`,
    `Gladwin County`,
    `Gogebic County`,
    `Grand Traverse County`,
    `Gratiot County`,
    `Hillsdale County`,
    `Houghton County`,
    `Huron County`,
    `Ingham County`,
    `Ionia County`,
    `Iosco County`,
    `Iron County`,
    `Isabella County`,
    `Jackson County`,
    `Kalamazoo County`,
    `Kalkaska County`,
    `Kent County`,
    `Keweenaw County`,
    `Lake County`,
    `Lapeer County`,
    `Leelanau County`,
    `Lenawee County`,
    `Livingston County`,
    `Luce County`,
    `Mackinac County`,
    `Macomb County`,
    `Manistee County`,
    `Marquette County`,
    `Mason County`,
    `Mecosta County`,
    `Menominee County`,
    `Midland County`,
    `Missaukee County`,
    `Monroe County`,
    `Montcalm County`,
    `Montmorency County`,
    `Muskegon County`,
    `Newaygo County`,
    `Oakland County`,
    `Oceana County`,
    `Ogemaw County`,
    `Ontonagon County`,
    `Osceola County`,
    `Oscoda County`,
    `Otsego County`,
    `Ottawa County`,
    `Presque Isle County`,
    `Roscommon County`,
    `Saginaw County`,
    `St. Clair County`,
    `St. Joseph County`,
    `Sanilac County`,
    `Schoolcraft County`,
    `Shiawassee County`,
    `Tuscola County`,
    `Van Buren County`,
    `Washtenaw County`,
    `Wayne County`,
    `Wexford County`,
    `N/A`,
  ],
  Minnesota: [
    `Aitkin County`,
    `Anoka County`,
    `Becker County`,
    `Beltrami County`,
    `Benton County`,
    `Big Stone County`,
    `Blue Earth County`,
    `Brown County`,
    `Carlton County`,
    `Carver County`,
    `Cass County`,
    `Chippewa County`,
    `Chisago County`,
    `Clay County`,
    `Clearwater County`,
    `Cook County`,
    `Cottonwood County`,
    `Crow Wing County`,
    `Dakota County`,
    `Dodge County`,
    `Douglas County`,
    `Faribault County`,
    `Fillmore County`,
    `Freeborn County`,
    `Goodhue County`,
    `Grant County`,
    `Hennepin County`,
    `Houston County`,
    `Hubbard County`,
    `Isanti County`,
    `Itasca County`,
    `Jackson County`,
    `Kanabec County`,
    `Kandiyohi County`,
    `Kittson County`,
    `Koochiching County`,
    `Lac qui Parle County`,
    `Lake County`,
    `Lake of the Woods County`,
    `Le Sueur County`,
    `Lincoln County`,
    `Lyon County`,
    `McLeod County`,
    `Mahnomen County`,
    `Marshall County`,
    `Martin County`,
    `Meeker County`,
    `Mille Lacs County`,
    `Morrison County`,
    `Mower County`,
    `Murray County`,
    `Nicollet County`,
    `Nobles County`,
    `Norman County`,
    `Olmsted County`,
    `Otter Tail County`,
    `Pennington County`,
    `Pine County`,
    `Pipestone County`,
    `Polk County`,
    `Pope County`,
    `Ramsey County`,
    `Red Lake County`,
    `Redwood County`,
    `Renville County`,
    `Rice County`,
    `Rock County`,
    `Roseau County`,
    `St. Louis County`,
    `Scott County`,
    `Sherburne County`,
    `Sibley County`,
    `Stearns County`,
    `Steele County`,
    `Stevens County`,
    `Swift County`,
    `Todd County`,
    `Traverse County`,
    `Wabasha County`,
    `Wadena County`,
    `Waseca County`,
    `Washington County`,
    `Watonwan County`,
    `Wilkin County`,
    `Winona County`,
    `Wright County`,
    `Yellow Medicine County`,
    `N/A`,
  ],
  Mississippi: [
    `Adams County`,
    `Alcorn County`,
    `Amite County`,
    `Attala County`,
    `Benton County`,
    `Bolivar County`,
    `Calhoun County`,
    `Carroll County`,
    `Chickasaw County`,
    `Choctaw County`,
    `Claiborne County`,
    `Clarke County`,
    `Clay County`,
    `Coahoma County`,
    `Copiah County`,
    `Covington County`,
    `DeSoto County`,
    `Forrest County`,
    `Franklin County`,
    `George County`,
    `Greene County`,
    `Grenada County`,
    `Hancock County`,
    `Harrison County`,
    `Hinds County`,
    `Holmes County`,
    `Humphreys County`,
    `Issaquena County`,
    `Itawamba County`,
    `Jackson County`,
    `Jasper County`,
    `Jefferson County`,
    `Jefferson Davis County`,
    `Jones County`,
    `Kemper County`,
    `Lafayette County`,
    `Lamar County`,
    `Lauderdale County`,
    `Lawrence County`,
    `Leake County`,
    `Lee County`,
    `Leflore County`,
    `Lincoln County`,
    `Lowndes County`,
    `Madison County`,
    `Marion County`,
    `Marshall County`,
    `Monroe County`,
    `Montgomery County`,
    `Neshoba County`,
    `Newton County`,
    `Noxubee County`,
    `Oktibbeha County`,
    `Panola County`,
    `Pearl River County`,
    `Perry County`,
    `Pike County`,
    `Pontotoc County`,
    `Prentiss County`,
    `Quitman County`,
    `Rankin County`,
    `Scott County`,
    `Sharkey County`,
    `Simpson County`,
    `Smith County`,
    `Stone County`,
    `Sunflower County`,
    `Tallahatchie County`,
    `Tate County`,
    `Tippah County`,
    `Tishomingo County`,
    `Tunica County`,
    `Union County`,
    `Walthall County`,
    `Warren County`,
    `Washington County`,
    `Wayne County`,
    `Webster County`,
    `Wilkinson County`,
    `Winston County`,
    `Yalobusha County`,
    `Yazoo County`,
    `N/A`,
  ],
  Missouri: [
    `Adair County`,
    `Andrew County`,
    `Atchison County`,
    `Audrain County`,
    `Barry County`,
    `Barton County`,
    `Bates County`,
    `Benton County`,
    `Bollinger County`,
    `Boone County`,
    `Buchanan County`,
    `Butler County`,
    `Caldwell County`,
    `Callaway County`,
    `Camden County`,
    `Cape Girardeau County`,
    `Carroll County`,
    `Carter County`,
    `Cass County`,
    `Cedar County`,
    `Chariton County`,
    `Christian County`,
    `Clark County`,
    `Clay County`,
    `Clinton County`,
    `Cole County`,
    `Cooper County`,
    `Crawford County`,
    `Dade County`,
    `Dallas County`,
    `Daviess County`,
    `DeKalb County`,
    `Dent County`,
    `Douglas County`,
    `Dunklin County`,
    `Franklin County`,
    `Gasconade County`,
    `Gentry County`,
    `Greene County`,
    `Grundy County`,
    `Harrison County`,
    `Henry County`,
    `Hickory County`,
    `Holt County`,
    `Howard County`,
    `Howell County`,
    `Iron County`,
    `Jackson County`,
    `Jasper County`,
    `Jefferson County`,
    `Johnson County`,
    `Knox County`,
    `Laclede County`,
    `Lafayette County`,
    `Lawrence County`,
    `Lewis County`,
    `Lincoln County`,
    `Linn County`,
    `Livingston County`,
    `McDonald County`,
    `Macon County`,
    `Madison County`,
    `Maries County`,
    `Marion County`,
    `Mercer County`,
    `Miller County`,
    `Mississippi County`,
    `Moniteau County`,
    `Monroe County`,
    `Montgomery County`,
    `Morgan County`,
    `New Madrid County`,
    `Newton County`,
    `Nodaway County`,
    `Oregon County`,
    `Osage County`,
    `Ozark County`,
    `Pemiscot County`,
    `Perry County`,
    `Pettis County`,
    `Phelps County`,
    `Pike County`,
    `Platte County`,
    `Polk County`,
    `Pulaski County`,
    `Putnam County`,
    `Ralls County`,
    `Randolph County`,
    `Ray County`,
    `Reynolds County`,
    `Ripley County`,
    `St. Charles County`,
    `St. Clair County`,
    `Ste. Genevieve County`,
    `St. Francois County`,
    `St. Louis city`,
    `St. Louis County`,
    `Saline County`,
    `Schuyler County`,
    `Scotland County`,
    `Scott County`,
    `Shannon County`,
    `Shelby County`,
    `Stoddard County`,
    `Stone County`,
    `Sullivan County`,
    `Taney County`,
    `Texas County`,
    `Vernon County`,
    `Warren County`,
    `Washington County`,
    `Wayne County`,
    `Webster County`,
    `Worth County`,
    `Wright County`,
    `N/A`,
  ],
  Montana: [
    `Beaverhead County`,
    `Big Horn County`,
    `Blaine County`,
    `Broadwater County`,
    `Carbon County`,
    `Carter County`,
    `Cascade County`,
    `Chouteau County`,
    `Custer County`,
    `Daniels County`,
    `Dawson County`,
    `Deer Lodge County`,
    `Fallon County`,
    `Fergus County`,
    `Flathead County`,
    `Gallatin County`,
    `Garfield County`,
    `Glacier County`,
    `Golden Valley County`,
    `Granite County`,
    `Hill County`,
    `Jefferson County`,
    `Judith Basin County`,
    `Lake County`,
    `Lewis and Clark County`,
    `Liberty County`,
    `Lincoln County`,
    `McCone County`,
    `Madison County`,
    `Meagher County`,
    `Mineral County`,
    `Missoula County`,
    `Musselshell County`,
    `Park County`,
    `Petroleum County`,
    `Phillips County`,
    `Pondera County`,
    `Powder River County`,
    `Powell County`,
    `Prairie County`,
    `Ravalli County`,
    `Richland County`,
    `Roosevelt County`,
    `Rosebud County`,
    `Sanders County`,
    `Sheridan County`,
    `Silver Bow County`,
    `Stillwater County`,
    `Sweet Grass County`,
    `Teton County`,
    `Toole County`,
    `Treasure County`,
    `Valley County`,
    `Wheatland County`,
    `Wibaux County`,
    `Yellowstone County`,
    `Yellowstone National Park`,
    `N/A`,
  ],
  Nebraska: [
    `Adams County`,
    `Antelope County`,
    `Arthur County`,
    `Banner County`,
    `Blaine County`,
    `Boone County`,
    `Box Butte County`,
    `Boyd County`,
    `Brown County`,
    `Buffalo County`,
    `Burt County`,
    `Butler County`,
    `Cass County`,
    `Cedar County`,
    `Chase County`,
    `Cherry County`,
    `Cheyenne County`,
    `Clay County`,
    `Colfax County`,
    `Cuming County`,
    `Custer County`,
    `Dakota County`,
    `Dawes County`,
    `Dawson County`,
    `Deuel County`,
    `Dixon County`,
    `Dodge County`,
    `Douglas County`,
    `Dundy County`,
    `Fillmore County`,
    `Franklin County`,
    `Frontier County`,
    `Furnas County`,
    `Gage County`,
    `Garden County`,
    `Garfield County`,
    `Gosper County`,
    `Grant County`,
    `Greeley County`,
    `Hall County`,
    `Hamilton County`,
    `Harlan County`,
    `Hayes County`,
    `Hitchcock County`,
    `Holt County`,
    `Hooker County`,
    `Howard County`,
    `Jefferson County`,
    `Johnson County`,
    `Kearney County`,
    `Keith County`,
    `Keya Paha County`,
    `Kimball County`,
    `Knox County`,
    `Lancaster County`,
    `Lincoln County`,
    `Logan County`,
    `Loup County`,
    `McPherson County`,
    `Madison County`,
    `Merrick County`,
    `Morrill County`,
    `Nance County`,
    `Nemaha County`,
    `Nuckolls County`,
    `Otoe County`,
    `Pawnee County`,
    `Perkins County`,
    `Phelps County`,
    `Pierce County`,
    `Platte County`,
    `Polk County`,
    `Red Willow County`,
    `Richardson County`,
    `Rock County`,
    `Saline County`,
    `Sarpy County`,
    `Saunders County`,
    `Scotts Bluff County`,
    `Seward County`,
    `Sheridan County`,
    `Sherman County`,
    `Sioux County`,
    `Stanton County`,
    `Thayer County`,
    `Thomas County`,
    `Thurston County`,
    `Valley County`,
    `Washington County`,
    `Wayne County`,
    `Webster County`,
    `Wheeler County`,
    `York County`,
    `N/A`,
  ],
  Nevada: [
    `Churchill County`,
    `Clark County`,
    `Douglas County`,
    `Elko County`,
    `Esmeralda County`,
    `Eureka County`,
    `Humboldt County`,
    `Lander County`,
    `Lincoln County`,
    `Lyon County`,
    `Mineral County`,
    `Nye County`,
    `Pershing County`,
    `Storey County`,
    `Washoe County`,
    `White Pine County`,
    `Carson City`,
    `N/A`,
  ],
  'New Hampshire': [
    `Belknap County`,
    `Carroll County`,
    `Cheshire County`,
    `Coos County`,
    `Grafton County`,
    `Hillsborough County`,
    `Merrimack County`,
    `Rockingham County`,
    `Strafford County`,
    `Sullivan County`,
    `N/A`,
  ],
  'New Jersey': [
    `Atlantic County`,
    `Bergen County`,
    `Burlington County`,
    `Camden County`,
    `Cape May County`,
    `Cumberland County`,
    `Essex County`,
    `Gloucester County`,
    `Hudson County`,
    `Hunterdon County`,
    `Mercer County`,
    `Middlesex County`,
    `Monmouth County`,
    `Morris County`,
    `Ocean County`,
    `Passaic County`,
    `Salem County`,
    `Somerset County`,
    `Sussex County`,
    `Union County`,
    `Warren County`,
    `N/A`,
  ],
  'New Mexico': [
    `Bernalillo County`,
    `Catron County`,
    `Chaves County`,
    `Cibola County`,
    `Colfax County`,
    `Curry County`,
    `DeBaca County`,
    `Doña Ana County`,
    `Eddy County`,
    `Grant County`,
    `Guadalupe County`,
    `Harding County`,
    `Hidalgo County`,
    `Lea County`,
    `Lincoln County`,
    `Los Alamos County`,
    `Luna County`,
    `McKinley County`,
    `Mora County`,
    `Otero County`,
    `Quay County`,
    `Rio Arriba County`,
    `Roosevelt County`,
    `Sandoval County`,
    `San Juan County`,
    `San Miguel County`,
    `Santa Fe County`,
    `Sierra County`,
    `Socorro County`,
    `Taos County`,
    `Torrance County`,
    `Union County`,
    `Valencia County`,
    `N/A`,
  ],
  'New York': [
    `Bernalillo County`,
    `Catron County`,
    `Chaves County`,
    `Cibola County`,
    `Colfax County`,
    `Curry County`,
    `DeBaca County`,
    `Doña Ana County`,
    `Eddy County`,
    `Grant County`,
    `Guadalupe County`,
    `Harding County`,
    `Hidalgo County`,
    `Lea County`,
    `Lincoln County`,
    `Los Alamos County`,
    `Luna County`,
    `McKinley County`,
    `Mora County`,
    `Otero County`,
    `Quay County`,
    `Rio Arriba County`,
    `Roosevelt County`,
    `Sandoval County`,
    `San Juan County`,
    `San Miguel County`,
    `Santa Fe County`,
    `Sierra County`,
    `Socorro County`,
    `Taos County`,
    `Torrance County`,
    `Union County`,
    `Valencia County`,
    `N/A`,
  ],
  'North Carolina': [
    `Alamance County`,
    `Alexander County`,
    `Alleghany County`,
    `Anson County`,
    `Ashe County`,
    `Avery County`,
    `Beaufort County`,
    `Bertie County`,
    `Bladen County`,
    `Brunswick County`,
    `Buncombe County`,
    `Burke County`,
    `Cabarrus County`,
    `Caldwell County`,
    `Camden County`,
    `Carteret County`,
    `Caswell County`,
    `Catawba County`,
    `Chatham County`,
    `Cherokee County`,
    `Chowan County`,
    `Clay County`,
    `Cleveland County`,
    `Columbus County`,
    `Craven County`,
    `Cumberland County`,
    `Currituck County`,
    `Dare County`,
    `Davidson County`,
    `Davie County`,
    `Duplin County`,
    `Durham County`,
    `Edgecombe County`,
    `Forsyth County`,
    `Franklin County`,
    `Gaston County`,
    `Gates County`,
    `Graham County`,
    `Granville County`,
    `Greene County`,
    `Guilford County`,
    `Halifax County`,
    `Harnett County`,
    `Haywood County`,
    `Henderson County`,
    `Hertford County`,
    `Hoke County`,
    `Hyde County`,
    `Iredell County`,
    `Jackson County`,
    `Johnston County`,
    `Jones County`,
    `Lee County`,
    `Lenoir County`,
    `Lincoln County`,
    `McDowell County`,
    `Macon County`,
    `Madison County`,
    `Martin County`,
    `Mecklenburg County`,
    `Mitchell County`,
    `Montgomery County`,
    `Moore County`,
    `Nash County`,
    `New Hanover County`,
    `Northampton County`,
    `Onslow County`,
    `Orange County`,
    `Pamlico County`,
    `Pasquotank County`,
    `Pender County`,
    `Perquimans County`,
    `Person County`,
    `Pitt County`,
    `Polk County`,
    `Randolph County`,
    `Richmond County`,
    `Robeson County`,
    `Rockingham County`,
    `Rowan County`,
    `Rutherford County`,
    `Sampson County`,
    `Scotland County`,
    `Stanly County`,
    `Stokes County`,
    `Surry County`,
    `Swain County`,
    `Transylvania County`,
    `Tyrrell County`,
    `Union County`,
    `Vance County`,
    `Wake County`,
    `Warren County`,
    `Washington County`,
    `Watauga County`,
    `Wayne County`,
    `Wilkes County`,
    `Wilson County`,
    `Yadkin County`,
    `Yancey County`,
    `N/A`,
  ],
  'North Dakota': [
    `Adams County`,
    `Barnes County`,
    `Benson County`,
    `Billings County`,
    `Bottineau County`,
    `Bowman County`,
    `Burke County`,
    `Burleigh County`,
    `Cass County`,
    `Cavalier County`,
    `Dickey County`,
    `Divide County`,
    `Dunn County`,
    `Eddy County`,
    `Emmons County`,
    `Foster County`,
    `Golden Valley County`,
    `Grand Forks County`,
    `Grant County`,
    `Griggs County`,
    `Hettinger County`,
    `Kidder County`,
    `LaMoure County`,
    `Logan County`,
    `McHenry County`,
    `McIntosh County`,
    `McKenzie County`,
    `McLean County`,
    `Mercer County`,
    `Morton County`,
    `Mountrail County`,
    `Nelson County`,
    `Oliver County`,
    `Pembina County`,
    `Pierce County`,
    `Ramsey County`,
    `Ransom County`,
    `Renville County`,
    `Richland County`,
    `Rolette County`,
    `Sargent County`,
    `Sheridan County`,
    `Sioux County`,
    `Slope County`,
    `Stark County`,
    `Steele County`,
    `Stutsman County`,
    `Towner County`,
    `Traill County`,
    `Walsh County`,
    `Ward County`,
    `Wells County`,
    `Williams County`,
    `N/A`,
  ],
  'Northern Mariana Islands': [`N/A County`],
  Ohio: [
    `Adams County`,
    `Allen County`,
    `Ashland County`,
    `Ashtabula County`,
    `Athens County`,
    `Auglaize County`,
    `Belmont County`,
    `Brown County`,
    `Butler County`,
    `Carroll County`,
    `Champaign County`,
    `Clark County`,
    `Clermont County`,
    `Clinton County`,
    `Columbiana County`,
    `Coshocton County`,
    `Crawford County`,
    `Cuyahoga County`,
    `Darke County`,
    `Defiance County`,
    `Delaware County`,
    `Erie County`,
    `Fairfield County`,
    `Fayette County`,
    `Franklin County`,
    `Fulton County`,
    `Gallia County`,
    `Geauga County`,
    `Greene County`,
    `Guernsey County`,
    `Hamilton County`,
    `Hancock County`,
    `Hardin County`,
    `Harrison County`,
    `Henry County`,
    `Highland County`,
    `Hocking County`,
    `Holmes County`,
    `Huron County`,
    `Jackson County`,
    `Jefferson County`,
    `Knox County`,
    `Lake County`,
    `Lawrence County`,
    `Licking County`,
    `Logan County`,
    `Lorain County`,
    `Lucas County`,
    `Madison County`,
    `Mahoning County`,
    `Marion County`,
    `Medina County`,
    `Meigs County`,
    `Mercer County`,
    `Miami County`,
    `Monroe County`,
    `Montgomery County`,
    `Morgan County`,
    `Morrow County`,
    `Muskingum County`,
    `Noble County`,
    `Ottawa County`,
    `Paulding County`,
    `Perry County`,
    `Pickaway County`,
    `Pike County`,
    `Portage County`,
    `Preble County`,
    `Putnam County`,
    `Richland County`,
    `Ross County`,
    `Sandusky County`,
    `Scioto County`,
    `Seneca County`,
    `Shelby County`,
    `Stark County`,
    `Summit County`,
    `Trumbull County`,
    `Tuscarawas County`,
    `Union County`,
    `Van Wert County`,
    `Vinton County`,
    `Warren County`,
    `Washington County`,
    `Wayne County`,
    `Williams County`,
    `Wood County`,
    `Wyandot County`,
    `N/A`,
  ],
  Oklahoma: [
    `Adair County`,
    `Alfalfa County`,
    `Atoka County`,
    `Beaver County`,
    `Beckham County`,
    `Blaine County`,
    `Bryan County`,
    `Caddo County`,
    `Canadian County`,
    `Carter County`,
    `Cherokee County`,
    `Choctaw County`,
    `Cimarron County`,
    `Cleveland County`,
    `Coal County`,
    `Comanche County`,
    `Cotton County`,
    `Craig County`,
    `Creek County`,
    `Custer County`,
    `Delaware County`,
    `Dewey County`,
    `Ellis County`,
    `Garfield County`,
    `Garvin County`,
    `Grady County`,
    `Grant County`,
    `Greer County`,
    `Harmon County`,
    `Harper County`,
    `Haskell County`,
    `Hughes County`,
    `Jackson County`,
    `Jefferson County`,
    `Johnston County`,
    `Kay County`,
    `Kingfisher County`,
    `Kiowa County`,
    `Latimer County`,
    `Le Flore County`,
    `Lincoln County`,
    `Logan County`,
    `Love County`,
    `McClain County`,
    `McCurtain County`,
    `McIntosh County`,
    `Major County`,
    `Marshall County`,
    `Mayes County`,
    `Murray County`,
    `Muskogee County`,
    `Noble County`,
    `Nowata County`,
    `Okfuskee County`,
    `Oklahoma County`,
    `Okmulgee County`,
    `Osage County`,
    `Ottawa County`,
    `Pawnee County`,
    `Payne County`,
    `Pittsburg County`,
    `Pontotoc County`,
    `Pottawatomie County`,
    `Pushmataha County`,
    `Roger Mills County`,
    `Rogers County`,
    `Seminole County`,
    `Sequoyah County`,
    `Stephens County`,
    `Texas County`,
    `Tillman County`,
    `Tulsa County`,
    `Wagoner County`,
    `Washington County`,
    `Washita County`,
    `Woods County`,
    `Woodward County`,
    `N/A`,
  ],
  Oregon: [
    `Baker County`,
    `Benton County`,
    `Clackamas County`,
    `Clatsop County`,
    `Columbia County`,
    `Coos County`,
    `Crook County`,
    `Curry County`,
    `Deschutes County`,
    `Douglas County`,
    `Gilliam County`,
    `Grant County`,
    `Harney County`,
    `Hood River County`,
    `Jackson County`,
    `Jefferson County`,
    `Josephine County`,
    `Klamath County`,
    `Lake County`,
    `Lane County`,
    `Lincoln County`,
    `Linn County`,
    `Malheur County`,
    `Marion County`,
    `Morrow County`,
    `Multnomah County`,
    `Polk County`,
    `Sherman County`,
    `Tillamook County`,
    `Umatilla County`,
    `Union County`,
    `Wallowa County`,
    `Wasco County`,
    `Washington County`,
    `Wheeler County`,
    `Yamhill County`,
    `N/A`,
  ],
  Palau: [`N/A County`],
  Pennsylvania: [
    `Adams County`,
    `Allegheny County`,
    `Armstrong County`,
    `Beaver County`,
    `Bedford County`,
    `Berks County`,
    `Blair County`,
    `Bradford County`,
    `Bucks County`,
    `Butler County`,
    `Cambria County`,
    `Cameron County`,
    `Carbon County`,
    `Centre County`,
    `Chester County`,
    `Clarion County`,
    `Clearfield County`,
    `Clinton County`,
    `Columbia County`,
    `Crawford County`,
    `Cumberland County`,
    `Dauphin County`,
    `Delaware County`,
    `Elk County`,
    `Erie County`,
    `Fayette County`,
    `Forest County`,
    `Franklin County`,
    `Fulton County`,
    `Greene County`,
    `Huntingdon County`,
    `Indiana County`,
    `Jefferson County`,
    `Juniata County`,
    `Lackawanna County`,
    `Lancaster County`,
    `Lawrence County`,
    `Lebanon County`,
    `Lehigh County`,
    `Luzerne County`,
    `Lycoming County`,
    `Mc Kean County`,
    `Mercer County`,
    `Mifflin County`,
    `Monroe County`,
    `Montgomery County`,
    `Montour County`,
    `Northampton County`,
    `Northumberland County`,
    `Perry County`,
    `Philadelphia County`,
    `Pike County`,
    `Potter County`,
    `Schuylkill County`,
    `Snyder County`,
    `Somerset County`,
    `Sullivan County`,
    `Susquehanna County`,
    `Tioga County`,
    `Union County`,
    `Venango County`,
    `Warren County`,
    `Washington County`,
    `Wayne County`,
    `Westmoreland County`,
    `Wyoming County`,
    `York County`,
    `N/A`,
  ],
  'Puerto Rico': [`N/A County`],
  'Rhode Island': [
    `Bristol County`,
    `Kent County`,
    `Newport County`,
    `Providence County`,
    `Washington County`,
    `N/A`,
  ],
  'South Carolina': [
    `Aiken County`,
    `Allendale County`,
    `Anderson County`,
    `Bamberg County`,
    `Barnwell County`,
    `Beaufort County`,
    `Berkeley County`,
    `Calhoun County`,
    `Charleston County`,
    `Cherokee County`,
    `Chester County`,
    `Chesterfield County`,
    `Clarendon County`,
    `Colleton County`,
    `Darlington County`,
    `Dillon County`,
    `Dorchester County`,
    `Edgefield County`,
    `Fairfield County`,
    `Florence County`,
    `Georgetown County`,
    `Greenville County`,
    `Greenwood County`,
    `Hampton County`,
    `Horry County`,
    `Jasper County`,
    `Kershaw County`,
    `Lancaster County`,
    `Laurens County`,
    `Lee County`,
    `Lexington County`,
    `McCormick County`,
    `Marion County`,
    `Marlboro County`,
    `Newberry County`,
    `Oconee County`,
    `Orangeburg County`,
    `Pickens County`,
    `Richland County`,
    `Saluda County`,
    `Spartanburg County`,
    `Sumter County`,
    `Union County`,
    `Williamsburg County`,
    `York County`,
    `N/A`,
  ],
  'South Dakota': [
    `Aurora County`,
    `Beadle County`,
    `Bennett County`,
    `Bon Homme County`,
    `Brookings County`,
    `Brown County`,
    `Brule County`,
    `Buffalo County`,
    `Butte County`,
    `Campbell County`,
    `Charles Mix County`,
    `Clark County`,
    `Clay County`,
    `Codington County`,
    `Corson County`,
    `Custer County`,
    `Davison County`,
    `Day County`,
    `Deuel County`,
    `Dewey County`,
    `Douglas County`,
    `Edmunds County`,
    `Fall River County`,
    `Faulk County`,
    `Grant County`,
    `Gregory County`,
    `Haakon County`,
    `Hamlin County`,
    `Hand County`,
    `Hanson County`,
    `Harding County`,
    `Hughes County`,
    `Hutchinson County`,
    `Hyde County`,
    `Jackson County`,
    `Jerauld County`,
    `Jones County`,
    `Kingsbury County`,
    `Lake County`,
    `Lawrence County`,
    `Lincoln County`,
    `Lyman County`,
    `McCook County`,
    `McPherson County`,
    `Marshall County`,
    `Meade County`,
    `Mellette County`,
    `Miner County`,
    `Minnehaha County`,
    `Moody County`,
    `Pennington County`,
    `Perkins County`,
    `Potter County`,
    `Roberts County`,
    `Sanborn County`,
    `Spink County`,
    `Stanley County`,
    `Sully County`,
    `Todd County`,
    `Tripp County`,
    `Turner County`,
    `Union County`,
    `Walworth County`,
    `Yankton County`,
    `Ziebach County`,
    `N/A`,
  ],
  Tennessee: [
    `Anderson County`,
    `Bedford County`,
    `Benton County`,
    `Bledsoe County`,
    `Blount County`,
    `Bradley County`,
    `Campbell County`,
    `Cannon County`,
    `Carroll County`,
    `Carter County`,
    `Cheatham County`,
    `Chester County`,
    `Claiborne County`,
    `Clay County`,
    `Cocke County`,
    `Coffee County`,
    `Crockett County`,
    `Cumberland County`,
    `Davidson County`,
    `Decatur County`,
    `DeKalb County`,
    `Dickson County`,
    `Dyer County`,
    `Fayette County`,
    `Fentress County`,
    `Franklin County`,
    `Gibson County`,
    `Giles County`,
    `Grainger County`,
    `Greene County`,
    `Grundy County`,
    `Hamblen County`,
    `Hamilton County`,
    `Hancock County`,
    `Hardeman County`,
    `Hardin County`,
    `Hawkins County`,
    `Haywood County`,
    `Henderson County`,
    `Henry County`,
    `Hickman County`,
    `Houston County`,
    `Humphreys County`,
    `Jackson County`,
    `Jefferson County`,
    `Johnson County`,
    `Knox County`,
    `Lake County`,
    `Lauderdale County`,
    `Lawrence County`,
    `Lewis County`,
    `Lincoln County`,
    `Loudon County`,
    `McMinn County`,
    `McNairy County`,
    `Macon County`,
    `Madison County`,
    `Marion County`,
    `Marshall County`,
    `Maury County`,
    `Meigs County`,
    `Monroe County`,
    `Montgomery County`,
    `Moore County`,
    `Morgan County`,
    `Obion County`,
    `Overton County`,
    `Perry County`,
    `Pickett County`,
    `Polk County`,
    `Putnam County`,
    `Rhea County`,
    `Roane County`,
    `Robertson County`,
    `Rutherford County`,
    `Scott County`,
    `Sequatchie County`,
    `Sevier County`,
    `Shelby County`,
    `Smith County`,
    `Stewart County`,
    `Sullivan County`,
    `Sumner County`,
    `Tipton County`,
    `Trousdale County`,
    `Unicoi County`,
    `Union County`,
    `Van Buren County`,
    `Warren County`,
    `Washington County`,
    `Wayne County`,
    `Weakley County`,
    `White County`,
    `Williamson County`,
    `Wilson County`,
    `N/A`,
  ],
  Texas: [
    `Anderson County`,
    `Andrews County`,
    `Angelina County`,
    `Aransas County`,
    `Archer County`,
    `Armstrong County`,
    `Atascosa County`,
    `Austin County`,
    `Bailey County`,
    `Bandera County`,
    `Bastrop County`,
    `Baylor County`,
    `Bee County`,
    `Bell County`,
    `Bexar County`,
    `Blanco County`,
    `Borden County`,
    `Bosque County`,
    `Bowie County`,
    `Brazoria County`,
    `Brazos County`,
    `Brewster County`,
    `Briscoe County`,
    `Brooks County`,
    `Brown County`,
    `Burleson County`,
    `Burnet County`,
    `Caldwell County`,
    `Calhoun County`,
    `Callahan County`,
    `Cameron County`,
    `Camp County`,
    `Carson County`,
    `Cass County`,
    `Castro County`,
    `Chambers County`,
    `Cherokee County`,
    `Childress County`,
    `Clay County`,
    `Cochran County`,
    `Coke County`,
    `Coleman County`,
    `Collin County`,
    `Collingsworth County`,
    `Colorado County`,
    `Comal County`,
    `Comanche County`,
    `Concho County`,
    `Cooke County`,
    `Coryell County`,
    `Cottle County`,
    `Crane County`,
    `Crockett County`,
    `Crosby County`,
    `Culberson County`,
    `Dallam County`,
    `Dallas County`,
    `Dawson County`,
    `Deaf Smith County`,
    `Delta County`,
    `Denton County`,
    `DeWitt County`,
    `Dickens County`,
    `Dimmit County`,
    `Donley County`,
    `Duval County`,
    `Eastland County`,
    `Ector County`,
    `Edwards County`,
    `Ellis County`,
    `El Paso County`,
    `Erath County`,
    `Falls County`,
    `Fannin County`,
    `Fayette County`,
    `Fisher County`,
    `Floyd County`,
    `Foard County`,
    `Fort Bend County`,
    `Franklin County`,
    `Freestone County`,
    `Frio County`,
    `Gaines County`,
    `Galveston County`,
    `Garza County`,
    `Gillespie County`,
    `Glasscock County`,
    `Goliad County`,
    `Gonzales County`,
    `Gray County`,
    `Grayson County`,
    `Gregg County`,
    `Grimes County`,
    `Guadalupe County`,
    `Hale County`,
    `Hall County`,
    `Hamilton County`,
    `Hansford County`,
    `Hardeman County`,
    `Hardin County`,
    `Harris County`,
    `Harrison County`,
    `Hartley County`,
    `Haskell County`,
    `Hays County`,
    `Hemphill County`,
    `Henderson County`,
    `Hidalgo County`,
    `Hill County`,
    `Hockley County`,
    `Hood County`,
    `Hopkins County`,
    `Houston County`,
    `Howard County`,
    `Hudspeth County`,
    `Hunt County`,
    `Hutchinson County`,
    `Irion County`,
    `Jack County`,
    `Jackson County`,
    `Jasper County`,
    `Jeff Davis County`,
    `Jefferson County`,
    `Jim Hogg County`,
    `Jim Wells County`,
    `Johnson County`,
    `Jones County`,
    `Karnes County`,
    `Kaufman County`,
    `Kendall County`,
    `Kenedy County`,
    `Kent County`,
    `Kerr County`,
    `Kimble County`,
    `King County`,
    `Kinney County`,
    `Kleberg County`,
    `Knox County`,
    `Lamar County`,
    `Lamb County`,
    `Lampasas County`,
    `La Salle County`,
    `Lavaca County`,
    `Lee County`,
    `Leon County`,
    `Liberty County`,
    `Limestone County`,
    `Lipscomb County`,
    `Live Oak County`,
    `Llano County`,
    `Loving County`,
    `Lubbock County`,
    `Lynn County`,
    `McCulloch County`,
    `McLennan County`,
    `McMullen County`,
    `Madison County`,
    `Marion County`,
    `Martin County`,
    `Mason County`,
    `Matagorda County`,
    `Maverick County`,
    `Medina County`,
    `Menard County`,
    `Midland County`,
    `Milam County`,
    `Mills County`,
    `Mitchell County`,
    `Montague County`,
    `Montgomery County`,
    `Moore County`,
    `Morris County`,
    `Motley County`,
    `Nacogdoches County`,
    `Navarro County`,
    `Newton County`,
    `Nolan County`,
    `Nueces County`,
    `Ochiltree County`,
    `Oldham County`,
    `Orange County`,
    `Palo Pinto County`,
    `Panola County`,
    `Parker County`,
    `Parmer County`,
    `Pecos County`,
    `Polk County`,
    `Potter County`,
    `Presidio County`,
    `Rains County`,
    `Randall County`,
    `Reagan County`,
    `Real County`,
    `Red River County`,
    `Reeves County`,
    `Refugio County`,
    `Roberts County`,
    `Robertson County`,
    `Rockwall County`,
    `Runnels County`,
    `Rusk County`,
    `Sabine County`,
    `San Augustine County`,
    `San Jacinto County`,
    `San Patricio County`,
    `San Saba County`,
    `Schleicher County`,
    `Scurry County`,
    `Shackelford County`,
    `Shelby County`,
    `Sherman County`,
    `Smith County`,
    `Somervell County`,
    `Starr County`,
    `Stephens County`,
    `Sterling County`,
    `Stonewall County`,
    `Sutton County`,
    `Swisher County`,
    `Tarrant County`,
    `Taylor County`,
    `Terrell County`,
    `Terry County`,
    `Throckmorton County`,
    `Titus County`,
    `Tom Green County`,
    `Travis County`,
    `Trinity County`,
    `Tyler County`,
    `Upshur County`,
    `Upton County`,
    `Uvalde County`,
    `Val Verde County`,
    `Van Zandt County`,
    `Victoria County`,
    `Walker County`,
    `Waller County`,
    `Ward County`,
    `Washington County`,
    `Webb County`,
    `Wharton County`,
    `Wheeler County`,
    `Wichita County`,
    `Wilbarger County`,
    `Willacy County`,
    `Williamson County`,
    `Wilson County`,
    `Winkler County`,
    `Wise County`,
    `Wood County`,
    `Yoakum County`,
    `Young County`,
    `Zapata County`,
    `Zavala County`,
    `N/A`,
  ],
  'United States Minor Outlaying Islands': [`N/A County`],
  Utah: [
    `Beaver County`,
    `Box Elder County`,
    `Cache County`,
    `Carbon County`,
    `Daggett County`,
    `Davis County`,
    `Duchesne County`,
    `Emery County`,
    `Garfield County`,
    `Grand County`,
    `Iron County`,
    `Juab County`,
    `Kane County`,
    `Millard County`,
    `Morgan County`,
    `Piute County`,
    `Rich County`,
    `Salt Lake County`,
    `San Juan County`,
    `Sanpete County`,
    `Sevier County`,
    `Summit County`,
    `Tooele County`,
    `Uintah County`,
    `Utah County`,
    `Wasatch County`,
    `Washington County`,
    `Wayne County`,
    `Weber County`,
    `N/A`,
  ],
  Vermont: [
    `Addison County`,
    `Bennington County`,
    `Caledonia County`,
    `Chittenden County`,
    `Essex County`,
    `Franklin County`,
    `Grand Isle County`,
    `Lamoille County`,
    `Orange County`,
    `Orleans County`,
    `Rutland County`,
    `Washington County`,
    `Windham County`,
    `Windsor County`,
    `N/A`,
  ],
  'Virgin Islands, U.S.': [`N/A County`],
  Virginia: [
    `Accomack County`,
    `Albemarle County`,
    `Alleghany County`,
    `Amelia County`,
    `Amherst County`,
    `Appomattox County`,
    `Arlington County`,
    `Augusta County`,
    `Bath County`,
    `Bedford County`,
    `Bland County`,
    `Botetourt County`,
    `Brunswick County`,
    `Buchanan County`,
    `Buckingham County`,
    `Campbell County`,
    `Caroline County`,
    `Carroll County`,
    `Charles City County`,
    `Charlotte County`,
    `Chesterfield County`,
    `Clarke County`,
    `Craig County`,
    `Culpeper County`,
    `Cumberland County`,
    `Dickenson County`,
    `Dinwiddie County`,
    `Essex County`,
    `Fairfax County`,
    `Fauquier County`,
    `Floyd County`,
    `Fluvanna County`,
    `Franklin County`,
    `Frederick County`,
    `Giles County`,
    `Gloucester County`,
    `Goochland County`,
    `Grayson County`,
    `Greene County`,
    `Greensville County`,
    `Halifax County`,
    `Hanover County`,
    `Henrico County`,
    `Henry County`,
    `Highland County`,
    `Isle of Wight County`,
    `James City County`,
    `King and Queen County`,
    `King George County`,
    `King William County`,
    `Lancaster County`,
    `Lee County`,
    `Loudoun County`,
    `Louisa County`,
    `Lunenburg County`,
    `Madison County`,
    `Mathews County`,
    `Mecklenburg County`,
    `Middlesex County`,
    `Montgomery County`,
    `Nelson County`,
    `New Kent County`,
    `Northampton County`,
    `Northumberland County`,
    `Nottoway County`,
    `Orange County`,
    `Page County`,
    `Patrick County`,
    `Pittsylvania County`,
    `Powhatan County`,
    `Prince Edward County`,
    `Prince George County`,
    `Prince William County`,
    `Pulaski County`,
    `Rappahannock County`,
    `Richmond County`,
    `Roanoke County`,
    `Rockbridge County`,
    `Rockingham County`,
    `Russell County`,
    `Scott County`,
    `Shenandoah County`,
    `Smyth County`,
    `Southampton County`,
    `Spotsylvania County`,
    `Stafford County`,
    `Surry County`,
    `Sussex County`,
    `Tazewell County`,
    `Warren County`,
    `Washington County`,
    `Westmoreland County`,
    `Wise County`,
    `Wythe County`,
    `York County`,
    `Alexandria City`,
    `Bristol City`,
    `Buena Vista City`,
    `Charlottesville City`,
    `Chesapeake City`,
    `Colonial Heights City`,
    `Covington City`,
    `Danville City`,
    `Emporia City`,
    `Fairfax City`,
    `Falls Church City`,
    `Franklin City`,
    `Fredericksburg City`,
    `Galax City`,
    `Hampton City`,
    `Harrisonburg City`,
    `Hopewell City`,
    `Lexington City`,
    `Lynchburg City`,
    `Manassas City`,
    `Manassas Park City`,
    `Martinsville City`,
    `Newport News City`,
    `Norfolk City`,
    `Norton City`,
    `Petersburg City`,
    `Poquoson City`,
    `Portsmouth City`,
    `Radford City`,
    `Richmond City`,
    `Roanoke, City`,
    `Salem City`,
    `Staunton City`,
    `Suffolk City`,
    `Virginia Beach City`,
    `Waynesboro City`,
    `Williamsburg City`,
    `Winchester City`,
    `N/A`,
  ],
  Washington: [
    `Adams County`,
    `Asotin County`,
    `Benton County`,
    `Chelan County`,
    `Clallam County`,
    `Clark County`,
    `Columbia County`,
    `Cowlitz County`,
    `Douglas County`,
    `Ferry County`,
    `Franklin County`,
    `Garfield County`,
    `Grant County`,
    `Grays Harbor County`,
    `Island County`,
    `Jefferson County`,
    `King County`,
    `Kitsap County`,
    `Kittitas County`,
    `Klickitat County`,
    `Lewis County`,
    `Lincoln County`,
    `Mason County`,
    `Okanogan County`,
    `Pacific County`,
    `Pend Oreille County`,
    `Pierce County`,
    `San Juan County`,
    `Skagit County`,
    `Skamania County`,
    `Snohomish County`,
    `Spokane County`,
    `Stevens County`,
    `Thurston County`,
    `Wahkiakum County`,
    `Walla Walla County`,
    `Whatcom County`,
    `Whitman County`,
    `Yakima County`,
    `N/A`,
  ],
  'West Virginia': [
    `Barbour County`,
    `Berkeley County`,
    `Boone County`,
    `Braxton County`,
    `Brooke County`,
    `Cabell County`,
    `Calhoun County`,
    `Clay County`,
    `Doddridge County`,
    `Fayette County`,
    `Gilmer County`,
    `Grant County`,
    `Greenbrier County`,
    `Hampshire County`,
    `Hancock County`,
    `Hardy County`,
    `Harrison County`,
    `Jackson County`,
    `Jefferson County`,
    `Kanawha County`,
    `Lewis County`,
    `Lincoln County`,
    `Logan County`,
    `McDowell County`,
    `Marion County`,
    `Marshall County`,
    `Mason County`,
    `Mercer County`,
    `Mineral County`,
    `Mingo County`,
    `Monongalia County`,
    `Monroe County`,
    `Morgan County`,
    `Nicholas County`,
    `Ohio County`,
    `Pendleton County`,
    `Pleasants County`,
    `Pocahontas County`,
    `Preston County`,
    `Putnam County`,
    `Raleigh County`,
    `Randolph County`,
    `Ritchie County`,
    `Roane County`,
    `Summers County`,
    `Taylor County`,
    `Tucker County`,
    `Tyler County`,
    `Upshur County`,
    `Wayne County`,
    `Webster County`,
    `Wetzel County`,
    `Wirt County`,
    `Wood County`,
    `Wyoming County`,
    `N/A`,
  ],
  Wisconsin: [
    `Adams County`,
    `Ashland County`,
    `Barron County`,
    `Bayfield County`,
    `Brown County`,
    `Buffalo County`,
    `Burnett County`,
    `Calumet County`,
    `Chippewa County`,
    `Clark County`,
    `Columbia County`,
    `Crawford County`,
    `Dane County`,
    `Dodge County`,
    `Door County`,
    `Douglas County`,
    `Dunn County`,
    `Eau Claire County`,
    `Florence County`,
    `Fond du Lac County`,
    `Forest County`,
    `Grant County`,
    `Green County`,
    `Green Lake County`,
    `Iowa County`,
    `Iron County`,
    `Jackson County`,
    `Jefferson County`,
    `Juneau County`,
    `Kenosha County`,
    `Kewaunee County`,
    `La Crosse County`,
    `Lafayette County`,
    `Langlade County`,
    `Lincoln County`,
    `Manitowoc County`,
    `Marathon County`,
    `Marinette County`,
    `Marquette County`,
    `Menominee County`,
    `Milwaukee County`,
    `Monroe County`,
    `Oconto County`,
    `Oneida County`,
    `Outagamie County`,
    `Ozaukee County`,
    `Pepin County`,
    `Pierce County`,
    `Polk County`,
    `Portage County`,
    `Price County`,
    `Racine County`,
    `Richland County`,
    `Rock County`,
    `Rusk County`,
    `St. Croix County`,
    `Sauk County`,
    `Sawyer County`,
    `Shawano County`,
    `Sheboygan County`,
    `Taylor County`,
    `Trempealeau County`,
    `Vernon County`,
    `Vilas County`,
    `Walworth County`,
    `Washburn County`,
    `Washington County`,
    `Waukesha County`,
    `Waupaca County`,
    `Waushara County`,
    `Winnebago County`,
    `Wood County`,
    `N/A`,
  ],
  Wyoming: [
    `Albany County`,
    `Big Horn County`,
    `Campbell County`,
    `Carbon County`,
    `Converse County`,
    `Crook County`,
    `Fremont County`,
    `Goshen County`,
    `Hot Springs County`,
    `Johnson County`,
    `Laramie County`,
    `Lincoln County`,
    `Natrona County`,
    `Niobrara County`,
    `Park County`,
    `Platte County`,
    `Sheridan County`,
    `Sublette County`,
    `Sweetwater County`,
    `Teton County`,
    `Uinta County`,
    `Washakie County`,
    `Weston County`,
    `N/A`,
  ],
};

export const usaState = [
  'Alabama',
  'Alaska',
  'Armed Forces - Americas',
  'Armed Forces - Europe, African, Canada, Middle East',
  'Armed Forces - Pacific',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado ',
  'Connecticut',
  'Delware',
  'District of Columbia',
  'Federated States of Micronesia',
  'Florida',
  'Georgia',
  'Guam',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky ',
  'Louisiana',
  'Maine',
  'Marshall Islands',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Northern Mariana Islands',
  'Ohio',
  'Oklahoma ',
  'Oregon',
  'Palau',
  'Pennsylvania',
  'Puerto Rico ',
  'Road Island',
  'American Somoa ',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'United States Minor Outlying Islands ',
  'Utah',
  'Vermont',
  'Virgin Islands, U.S. ',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const canadaProvince = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  'Ontario',
  'Prince Edward Island',
  'Québec',
  'Saskatchewan',
  'Yukon',
];


// These options for Parent1, Parent2 pages:
export const priorCountryOptions = ["United States", "Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas, The", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia (Plurinational State of)", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory (the)", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Cayman Islands (the)", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands (the)", "Colombia", "Comoros", "Congo (the Democratic Republic of the)", "Congo (the)", "Cook Islands (the)", "Costa Rica", "Côte d'Ivoire", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Falkland Islands (the) [Malvinas]", "Faroe Islands (the)", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories (the)", "Gabon", "Gambia, The", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea (the Democratic People's Republic of)", "Korea (the Republic of)", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic (the)", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova (the Republic of)", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "North Macedonia", "Northern Mariana Islands (the)", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Réunion", "Romania", "Russian Federation (the)", "Rwanda", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan (Province of China)", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands (the)", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom of Great Britain and Northern Ireland (the)", "United States Minor Outlying Islands (the)", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela (Bolivarian Republic of)", "Viet Nam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna", "Western Sahara*", "Yemen", "Zambia", "Zimbabwe"];

export const objectCountries = [
  {
    "id": 222,
    "name": "United States",
    "code": "US"
  }, {
    "id": 33,
    "name": "Afghanistan",
    "code": "AF"
  }, {
    "id": 11995,
    "name": "Åland Islands",
    "code": "AX"
  }, {
    "id": 34,
    "name": "Albania",
    "code": "AL"
  }, {
    "id": 35,
    "name": "Algeria",
    "code": "AG"
  }, {
    "id": 12038,
    "name": "American Samoa",
    "code": "ASM"
  }, {
    "id": 36,
    "name": "Andorra",
    "code": "AN"
  }, {
    "id": 37,
    "name": "Angola",
    "code": "AO"
  }, {
    "id": 11992,
    "name": "Anguilla",
    "code": "AI"
  }, {
    "id": 11993,
    "name": "Antarctica",
    "code": "AQ"
  }, {
    "id": 40,
    "name": "Antigua and Barbuda",
    "code": "AC"
  }, {
    "id": 41,
    "name": "Argentina",
    "code": "AR"
  }, {
    "id": 42,
    "name": "Armenia",
    "code": "AM"
  }, {
    "id": 11994,
    "name": "Aruba",
    "code": "AW"
  }, {
    "id": 43,
    "name": "Australia",
    "code": "AS"
  }, {
    "id": 44,
    "name": "Austria",
    "code": "AU"
  }, {
    "id": 45,
    "name": "Azerbaijan",
    "code": "AJ"
  }, {
    "id": 46,
    "name": "Bahamas, The",
    "code": "BF"
  }, {
    "id": 47,
    "name": "Bahrain",
    "code": "BA"
  }, {
    "id": 48,
    "name": "Bangladesh",
    "code": "BG"
  }, {
    "id": 49,
    "name": "Barbados",
    "code": "BB"
  }, {
    "id": 50,
    "name": "Belarus",
    "code": "BO"
  }, {
    "id": 51,
    "name": "Belgium",
    "code": "BE"
  }, {
    "id": 52,
    "name": "Belize",
    "code": "BH"
  }, {
    "id": 53,
    "name": "Benin",
    "code": "BN"
  }, {
    "id": 12040,
    "name": "Bermuda",
    "code": "BMU"
  }, {
    "id": 54,
    "name": "Bhutan",
    "code": "BT"
  }, {
    "id": 55,
    "name": "Bolivia (Plurinational State of)",
    "code": "BL"
  }, {
    "id": 11996,
    "name": "Bonaire, Sint Eustatius and Saba",
    "code": "BQ"
  }, {
    "id": 56,
    "name": "Bosnia and Herzegovina",
    "code": "BK"
  }, {
    "id": 57,
    "name": "Botswana",
    "code": "BC"
  }, {
    "id": 11997,
    "name": "Bouvet Island",
    "code": "BV"
  }, {
    "id": 58,
    "name": "Brazil",
    "code": "BR"
  }, {
    "id": 12014,
    "name": "British Indian Ocean Territory (the)",
    "code": "IO"
  }, {
    "id": 59,
    "name": "Brunei Darussalam",
    "code": "BX"
  }, {
    "id": 60,
    "name": "Bulgaria",
    "code": "BU"
  }, {
    "id": 61,
    "name": "Burkina Faso",
    "code": "UV"
  }, {
    "id": 63,
    "name": "Burundi",
    "code": "BY"
  }, {
    "id": 68,
    "name": "Cabo Verde",
    "code": "CV"
  }, {
    "id": 65,
    "name": "Cambodia",
    "code": "CB"
  }, {
    "id": 66,
    "name": "Cameroon",
    "code": "CM"
  }, {
    "id": 67,
    "name": "Canada",
    "code": "CA"
  }, {
    "id": 12016,
    "name": "Cayman Islands (the)",
    "code": "KY"
  }, {
    "id": 69,
    "name": "Central African Republic",
    "code": "CT"
  }, {
    "id": 70,
    "name": "Chad",
    "code": "CD"
  }, {
    "id": 71,
    "name": "Chile",
    "code": "CI"
  }, {
    "id": 72,
    "name": "China",
    "code": "CH"
  }, {
    "id": 12001,
    "name": "Christmas Island",
    "code": "CX"
  }, {
    "id": 11998,
    "name": "Cocos (Keeling) Islands (the)",
    "code": "CC"
  }, {
    "id": 73,
    "name": "Colombia",
    "code": "CO"
  }, {
    "id": 74,
    "name": "Comoros",
    "code": "CN"
  }, {
    "id": 76,
    "name": "Congo (the Democratic Republic of the)",
    "code": "CG"
  }, {
    "id": 75,
    "name": "Congo (the)",
    "code": "CF"
  }, {
    "id": 11999,
    "name": "Cook Islands (the)",
    "code": "CK"
  }, {
    "id": 77,
    "name": "Costa Rica",
    "code": "CS"
  }, {
    "id": 78,
    "name": "Côte d'Ivoire",
    "code": "IV"
  }, {
    "id": 79,
    "name": "Croatia",
    "code": "HR"
  }, {
    "id": 80,
    "name": "Cuba",
    "code": "CU"
  }, {
    "id": 12000,
    "name": "Curaçao",
    "code": "CW"
  }, {
    "id": 81,
    "name": "Cyprus",
    "code": "CY"
  }, {
    "id": 82,
    "name": "Czechia",
    "code": "EZ"
  }, {
    "id": 83,
    "name": "Denmark",
    "code": "DA"
  }, {
    "id": 85,
    "name": "Djibouti",
    "code": "DJ"
  }, {
    "id": 86,
    "name": "Dominica",
    "code": "DO"
  }, {
    "id": 87,
    "name": "Dominican Republic",
    "code": "DR"
  }, {
    "id": 89,
    "name": "Ecuador",
    "code": "EC"
  }, {
    "id": 90,
    "name": "Egypt",
    "code": "EG"
  }, {
    "id": 91,
    "name": "El Salvador",
    "code": "ES"
  }, {
    "id": 92,
    "name": "Equatorial Guinea",
    "code": "EK"
  }, {
    "id": 93,
    "name": "Eritrea",
    "code": "ER"
  }, {
    "id": 94,
    "name": "Estonia",
    "code": "EN"
  }, {
    "id": 203,
    "name": "Eswatini",
    "code": "WZ"
  }, {
    "id": 95,
    "name": "Ethiopia",
    "code": "ET"
  }, {
    "id": 12003,
    "name": "Falkland Islands (the) [Malvinas]",
    "code": "FK"
  }, {
    "id": 12004,
    "name": "Faroe Islands (the)",
    "code": "FO"
  }, {
    "id": 96,
    "name": "Fiji",
    "code": "FJ"
  }, {
    "id": 97,
    "name": "Finland",
    "code": "FI"
  }, {
    "id": 98,
    "name": "France",
    "code": "FR"
  }, {
    "id": 12005,
    "name": "French Guiana",
    "code": "GF"
  }, {
    "id": 12022,
    "name": "French Polynesia",
    "code": "PF"
  }, {
    "id": 12031,
    "name": "French Southern Territories (the)",
    "code": "TF"
  }, {
    "id": 99,
    "name": "Gabon",
    "code": "GB"
  }, {
    "id": 100,
    "name": "Gambia, The",
    "code": "GA"
  }, {
    "id": 101,
    "name": "Georgia",
    "code": "GG"
  }, {
    "id": 102,
    "name": "Germany",
    "code": "GM"
  }, {
    "id": 103,
    "name": "Ghana",
    "code": "GH"
  }, {
    "id": 12006,
    "name": "Gibraltar",
    "code": "GI"
  }, {
    "id": 104,
    "name": "Greece",
    "code": "GR"
  }, {
    "id": 12007,
    "name": "Greenland",
    "code": "GL"
  }, {
    "id": 105,
    "name": "Grenada",
    "code": "GJ"
  }, {
    "id": 12008,
    "name": "Guadeloupe",
    "code": "GP"
  }, {
    "id": 12010,
    "name": "Guam",
    "code": "GU"
  }, {
    "id": 106,
    "name": "Guatemala",
    "code": "GT"
  }, {
    "id": 12041,
    "name": "Guernsey",
    "code": "GGY"
  }, {
    "id": 107,
    "name": "Guinea",
    "code": "GV"
  }, {
    "id": 108,
    "name": "Guinea-Bissau",
    "code": "PU"
  }, {
    "id": 109,
    "name": "Guyana",
    "code": "GY"
  }, {
    "id": 110,
    "name": "Haiti",
    "code": "HA"
  }, {
    "id": 12012,
    "name": "Heard Island and McDonald Islands",
    "code": "HM"
  }, {
    "id": 111,
    "name": "Holy See",
    "code": "VT"
  }, {
    "id": 112,
    "name": "Honduras",
    "code": "HO"
  }, {
    "id": 12011,
    "name": "Hong Kong",
    "code": "HK"
  }, {
    "id": 113,
    "name": "Hungary",
    "code": "HU"
  }, {
    "id": 114,
    "name": "Iceland",
    "code": "IC"
  }, {
    "id": 115,
    "name": "India",
    "code": "IN"
  }, {
    "id": 116,
    "name": "Indonesia",
    "code": "ID"
  }, {
    "id": 117,
    "name": "Iran (Islamic Republic of)",
    "code": "IR"
  }, {
    "id": 118,
    "name": "Iraq",
    "code": "IZ"
  }, {
    "id": 119,
    "name": "Ireland",
    "code": "EI"
  }, {
    "id": 12013,
    "name": "Isle of Man",
    "code": "IM"
  }, {
    "id": 120,
    "name": "Israel",
    "code": "IS"
  }, {
    "id": 121,
    "name": "Italy",
    "code": "IT"
  }, {
    "id": 122,
    "name": "Jamaica",
    "code": "JM"
  }, {
    "id": 123,
    "name": "Japan",
    "code": "JA"
  }, {
    "id": 12015,
    "name": "Jersey",
    "code": "JE"
  }, {
    "id": 124,
    "name": "Jordan",
    "code": "JO"
  }, {
    "id": 125,
    "name": "Kazakhstan",
    "code": "KZ"
  }, {
    "id": 126,
    "name": "Kenya",
    "code": "KE"
  }, {
    "id": 127,
    "name": "Kiribati",
    "code": "KR"
  }, {
    "id": 128,
    "name": "Korea (the Democratic People's Republic of)",
    "code": "KN"
  }, {
    "id": 129,
    "name": "Korea (the Republic of)",
    "code": "KS"
  }, {
    "id": 130,
    "name": "Kuwait",
    "code": "KU"
  }, {
    "id": 131,
    "name": "Kyrgyzstan",
    "code": "KG"
  }, {
    "id": 132,
    "name": "Lao People's Democratic Republic (the)",
    "code": "LA"
  }, {
    "id": 133,
    "name": "Latvia",
    "code": "LG"
  }, {
    "id": 134,
    "name": "Lebanon",
    "code": "LE"
  }, {
    "id": 135,
    "name": "Lesotho",
    "code": "LT"
  }, {
    "id": 136,
    "name": "Liberia",
    "code": "LI"
  }, {
    "id": 137,
    "name": "Libya",
    "code": "LY"
  }, {
    "id": 138,
    "name": "Liechtenstein",
    "code": "LS"
  }, {
    "id": 139,
    "name": "Lithuania",
    "code": "LH"
  }, {
    "id": 140,
    "name": "Luxembourg",
    "code": "LU"
  }, {
    "id": 12042,
    "name": "Macao",
    "code": "MAC"
  }, {
    "id": 142,
    "name": "Madagascar",
    "code": "MA"
  }, {
    "id": 143,
    "name": "Malawi",
    "code": "MI"
  }, {
    "id": 144,
    "name": "Malaysia",
    "code": "MY"
  }, {
    "id": 145,
    "name": "Maldives",
    "code": "MV"
  }, {
    "id": 146,
    "name": "Mali",
    "code": "ML"
  }, {
    "id": 147,
    "name": "Malta",
    "code": "MT"
  }, {
    "id": 148,
    "name": "Marshall Islands",
    "code": "RM"
  }, {
    "id": 12018,
    "name": "Martinique",
    "code": "MQ"
  }, {
    "id": 149,
    "name": "Mauritania",
    "code": "MR"
  }, {
    "id": 150,
    "name": "Mauritius",
    "code": "MP"
  }, {
    "id": 12037,
    "name": "Mayotte",
    "code": "YT"
  }, {
    "id": 151,
    "name": "Mexico",
    "code": "MX"
  }, {
    "id": 152,
    "name": "Micronesia, Federated States of",
    "code": "FM"
  }, {
    "id": 153,
    "name": "Moldova (the Republic of)",
    "code": "MD"
  }, {
    "id": 154,
    "name": "Monaco",
    "code": "MN"
  }, {
    "id": 155,
    "name": "Mongolia",
    "code": "MG"
  }, {
    "id": 156,
    "name": "Montenegro",
    "code": "MJ"
  }, {
    "id": 12019,
    "name": "Montserrat",
    "code": "MS"
  }, {
    "id": 157,
    "name": "Morocco",
    "code": "MO"
  }, {
    "id": 158,
    "name": "Mozambique",
    "code": "MZ"
  }, {
    "id": 62,
    "name": "Myanmar",
    "code": "BM"
  }, {
    "id": 159,
    "name": "Namibia",
    "code": "WA"
  }, {
    "id": 160,
    "name": "Nauru",
    "code": "NR"
  }, {
    "id": 161,
    "name": "Nepal",
    "code": "NP"
  }, {
    "id": 162,
    "name": "Netherlands",
    "code": "NL"
  }, {
    "id": 12020,
    "name": "New Caledonia",
    "code": "NC"
  }, {
    "id": 163,
    "name": "New Zealand",
    "code": "NZ"
  }, {
    "id": 164,
    "name": "Nicaragua",
    "code": "NU"
  }, {
    "id": 165,
    "name": "Niger",
    "code": "NG"
  }, {
    "id": 166,
    "name": "Nigeria",
    "code": "NI"
  }, {
    "id": 12044,
    "name": "Niue",
    "code": "NIU"
  }, {
    "id": 12021,
    "name": "Norfolk Island",
    "code": "NF"
  }, {
    "id": 141,
    "name": "North Macedonia",
    "code": "MK"
  }, {
    "id": 12043,
    "name": "Northern Mariana Islands (the)",
    "code": "MNP"
  }, {
    "id": 167,
    "name": "Norway",
    "code": "NO"
  }, {
    "id": 168,
    "name": "Oman",
    "code": "MU"
  }, {
    "id": 169,
    "name": "Pakistan",
    "code": "PK"
  }, {
    "id": 170,
    "name": "Palau",
    "code": "PS"
  }, {
    "id": 12046,
    "name": "Palestine, State of",
    "code": "PSE"
  }, {
    "id": 171,
    "name": "Panama",
    "code": "PM"
  }, {
    "id": 172,
    "name": "Papua New Guinea",
    "code": "PP"
  }, {
    "id": 173,
    "name": "Paraguay",
    "code": "PA"
  }, {
    "id": 174,
    "name": "Peru",
    "code": "PE"
  }, {
    "id": 175,
    "name": "Philippines",
    "code": "RP"
  }, {
    "id": 12023,
    "name": "Pitcairn",
    "code": "PN"
  }, {
    "id": 176,
    "name": "Poland",
    "code": "PL"
  }, {
    "id": 177,
    "name": "Portugal",
    "code": "PO"
  }, {
    "id": 12024,
    "name": "Puerto Rico",
    "code": "PR"
  }, {
    "id": 178,
    "name": "Qatar",
    "code": "QA"
  }, {
    "id": 12025,
    "name": "Réunion",
    "code": "RE"
  }, {
    "id": 179,
    "name": "Romania",
    "code": "RO"
  }, {
    "id": 180,
    "name": "Russian Federation (the)",
    "code": "RS"
  }, {
    "id": 181,
    "name": "Rwanda",
    "code": "RW"
  }, {
    "id": 12039,
    "name": "Saint Barthélemy",
    "code": "BLM"
  }, {
    "id": 12026,
    "name": "Saint Helena, Ascension and Tristan da Cunha",
    "code": "SH"
  }, {
    "id": 182,
    "name": "Saint Kitts and Nevis",
    "code": "SC"
  }, {
    "id": 183,
    "name": "Saint Lucia",
    "code": "ST"
  }, {
    "id": 12017,
    "name": "Saint Martin (French part)",
    "code": "MF"
  }, {
    "id": 12045,
    "name": "Saint Pierre and Miquelon",
    "code": "SPM"
  }, {
    "id": 184,
    "name": "Saint Vincent and the Grenadines",
    "code": "VC"
  }, {
    "id": 185,
    "name": "Samoa",
    "code": "WS"
  }, {
    "id": 186,
    "name": "San Marino",
    "code": "SM"
  }, {
    "id": 187,
    "name": "Sao Tome and Principe",
    "code": "TP"
  }, {
    "id": 188,
    "name": "Saudi Arabia",
    "code": "SA"
  }, {
    "id": 189,
    "name": "Senegal",
    "code": "SG"
  }, {
    "id": 190,
    "name": "Serbia",
    "code": "RB"
  }, {
    "id": 191,
    "name": "Seychelles",
    "code": "SE"
  }, {
    "id": 192,
    "name": "Sierra Leone",
    "code": "SL"
  }, {
    "id": 193,
    "name": "Singapore",
    "code": "SN"
  }, {
    "id": 12029,
    "name": "Sint Maarten (Dutch part)",
    "code": "SX"
  }, {
    "id": 194,
    "name": "Slovakia",
    "code": "LO"
  }, {
    "id": 195,
    "name": "Slovenia",
    "code": "SI"
  }, {
    "id": 196,
    "name": "Solomon Islands",
    "code": "BP"
  }, {
    "id": 197,
    "name": "Somalia",
    "code": "SO"
  }, {
    "id": 198,
    "name": "South Africa",
    "code": "SF"
  }, {
    "id": 12009,
    "name": "South Georgia and the South Sandwich Islands",
    "code": "GS"
  }, {
    "id": 12028,
    "name": "South Sudan",
    "code": "SS"
  }, {
    "id": 199,
    "name": "Spain",
    "code": "SP"
  }, {
    "id": 200,
    "name": "Sri Lanka",
    "code": "CE"
  }, {
    "id": 201,
    "name": "Sudan",
    "code": "SU"
  }, {
    "id": 202,
    "name": "Suriname",
    "code": "NS"
  }, {
    "id": 12027,
    "name": "Svalbard and Jan Mayen",
    "code": "SJ"
  }, {
    "id": 204,
    "name": "Sweden",
    "code": "SW"
  }, {
    "id": 205,
    "name": "Switzerland",
    "code": "SZ"
  }, {
    "id": 206,
    "name": "Syrian Arab Republic",
    "code": "SY"
  }, {
    "id": 207,
    "name": "Taiwan (Province of China)",
    "code": "TW"
  }, {
    "id": 208,
    "name": "Tajikistan",
    "code": "TI"
  }, {
    "id": 209,
    "name": "Tanzania, United Republic of",
    "code": "TZ"
  }, {
    "id": 210,
    "name": "Thailand",
    "code": "TH"
  }, {
    "id": 88,
    "name": "Timor-Leste",
    "code": "TT"
  }, {
    "id": 211,
    "name": "Togo",
    "code": "TO"
  }, {
    "id": 12032,
    "name": "Tokelau",
    "code": "TK"
  }, {
    "id": 212,
    "name": "Tonga",
    "code": "TN"
  }, {
    "id": 213,
    "name": "Trinidad and Tobago",
    "code": "TD"
  }, {
    "id": 214,
    "name": "Tunisia",
    "code": "TS"
  }, {
    "id": 215,
    "name": "Turkey",
    "code": "TU"
  }, {
    "id": 216,
    "name": "Turkmenistan",
    "code": "TX"
  }, {
    "id": 12030,
    "name": "Turks and Caicos Islands (the)",
    "code": "TC"
  }, {
    "id": 217,
    "name": "Tuvalu",
    "code": "TV"
  }, {
    "id": 218,
    "name": "Uganda",
    "code": "UG"
  }, {
    "id": 219,
    "name": "Ukraine",
    "code": "UP"
  }, {
    "id": 220,
    "name": "United Arab Emirates",
    "code": "AE"
  }, {
    "id": 221,
    "name": "United Kingdom of Great Britain and Northern Ireland (the)",
    "code": "UK"
  }, {
    "id": 12033,
    "name": "United States Minor Outlying Islands (the)",
    "code": "UM"
  }, {
    "id": 223,
    "name": "Uruguay",
    "code": "UY"
  }, {
    "id": 224,
    "name": "Uzbekistan",
    "code": "UZ"
  }, {
    "id": 225,
    "name": "Vanuatu",
    "code": "NH"
  }, {
    "id": 226,
    "name": "Venezuela (Bolivarian Republic of)",
    "code": "VE"
  }, {
    "id": 227,
    "name": "Viet Nam",
    "code": "VM"
  }, {
    "id": 12034,
    "name": "Virgin Islands (British)",
    "code": "VG"
  }, {
    "id": 12035,
    "name": "Virgin Islands (U.S.)",
    "code": "VI"
  }, {
    "id": 12036,
    "name": "Wallis and Futuna",
    "code": "WF"
  }, {
    "id": 12002,
    "name": "Western Sahara*",
    "code": "EH"
  }, {
    "id": 228,
    "name": "Yemen",
    "code": "YM"
  }, {
    "id": 229,
    "name": "Zambia",
    "code": "ZA"
  }, {
    "id": 230,
    "name": "Zimbabwe",
    "code": "ZI"
  }
];